'use client';

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import { useRouter } from 'next/navigation';

export const BackButton = () => {
  const router = useRouter();

  return (
    <button
      onClick={() => router.back()}
      className="absolute left-0 top-0 flex items-center justify-center text-sm text-accent md:text-base"
    >
      <ChevronLeftRoundedIcon className="m-0 pr-[2px] leading-none" /> Back
    </button>
  );
};
